import axios from './globalAxios'
import urls from './urls'
/**
 * 获取sdkConfig
 * @method getSdkConfig
 * @param {string}   url
 * @return {Promise对象} 返回Promise对象
 */
function getSdkConfig(url) {
  return axios.post(urls.getSdkConfig, { url })
}
/**
 * 活动信息
 * @method getEventInfo
 * @param {number} 活动id
 */
function getEventInfo(id) {
  return axios.get(urls.getEventInfo, {
    params: {
      id
    },
  })
}

export default {
  getSdkConfig,
  getEventInfo
}
